import React from 'react';

import GoogleMap from '../GoogleMap/GoogleMap';
import StoreInfoCard from '../StoreInfoCard/StoreInfoCard';

import './Stores.css';

const Stores = () => {
  return (
    <div className="page-container" id="les-points-de-vente">
      <h2>Points de vente</h2>
      <GoogleMap />
      <StoreInfoCard />
    </div>
  );
};

export default Stores;



// WEBPACK FOOTER //
// ./src/Components/Stores/Stores.js